import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Download, Loader2, CheckCircle, RefreshCw } from 'lucide-react';

function ImportResultGrid({ cols, result, fields }) {
  return (
    <div className={`grid grid-cols-${cols} gap-${cols > 2 ? '2' : '4'} text-sm`}>
      {fields.map(({ label, value }) => (
        <div key={label} className="text-center p-2 bg-white dark:bg-background rounded">
          <p className={`${cols > 2 ? 'text-lg' : 'text-2xl'} font-bold text-primary`}>
            {typeof value === 'function' ? value(result) : value}
          </p>
          <p className="text-muted-foreground">{label}</p>
        </div>
      ))}
    </div>
  );
}

export function ImportCard({
  title, description, details, colorClass,
  importing, onImport, result, resultFields, resultCols = 2,
  buttonLabel, loadingLabel, extraResult, onResetImport, showReset,
}) {
  const colorMap = {
    indigo: { border: 'border-indigo-500/30', bg: 'bg-indigo-500/5', btn: 'bg-indigo-600 hover:bg-indigo-700', resultBg: 'bg-indigo-100', icon: 'text-indigo-600', text: 'text-indigo-800' },
    green: { border: 'border-green-500/30', bg: 'bg-green-500/5', btn: 'bg-green-600 hover:bg-green-700', resultBg: 'bg-green-100', icon: 'text-green-600', text: 'text-green-800' },
    blue: { border: 'border-blue-500/30', bg: 'bg-blue-500/5', btn: 'bg-blue-600 hover:bg-blue-700', resultBg: 'bg-blue-100', icon: 'text-blue-600', text: 'text-blue-800' },
    purple: { border: 'border-purple-500/30', bg: 'bg-purple-500/5', btn: 'bg-purple-600 hover:bg-purple-700', resultBg: 'bg-purple-100', icon: 'text-purple-600', text: 'text-purple-800' },
    teal: { border: 'border-teal-500/30', bg: 'bg-teal-500/5', btn: 'bg-teal-600 hover:bg-teal-700', resultBg: 'bg-teal-100', icon: 'text-teal-600', text: 'text-teal-800' },
  };
  const c = colorMap[colorClass] || colorMap.green;

  return (
    <Card className={`border-2 ${c.border} ${c.bg}`}>
      <CardHeader className="pb-3">
        <CardTitle className="font-heading flex items-center gap-2">
          <Download className={`w-5 h-5 ${c.icon}`} />
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {details && (
            <div className="text-sm text-muted-foreground">
              {details}
            </div>
          )}
          <Button
            onClick={onImport}
            disabled={importing}
            className={`${c.btn}${title.includes('Todo') ? ' w-full h-12 text-base' : ''}`}
            data-testid={`import-${colorClass}-btn`}
          >
            {importing ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                {loadingLabel || 'Importando...'}
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                {buttonLabel || 'Importar'}
              </>
            )}
          </Button>
          {importing && showReset && onResetImport && (
            <div className="mt-3 text-center">
              <Button
                variant="ghost"
                size="sm"
                onClick={onResetImport}
                className="text-muted-foreground hover:text-destructive"
                data-testid="reset-import-btn"
              >
                <RefreshCw className="w-3 h-3 mr-1" />
                Atorado? Resetear estado
              </Button>
            </div>
          )}
          {result && (
            <div className={`mt-4 p-4 ${c.resultBg} rounded-lg`}>
              <div className="flex items-center gap-2 mb-3">
                <CheckCircle className={`w-5 h-5 ${c.icon}`} />
                <span className={`font-medium ${c.text}`}>Importacion Completada</span>
              </div>
              {resultFields ? (
                <ImportResultGrid cols={resultCols} result={result} fields={resultFields} />
              ) : (
                <pre className="text-xs whitespace-pre-wrap">{JSON.stringify(result, null, 2)}</pre>
              )}
              {extraResult}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
